export default "__VITE_ASSET__DwOvpeeD__"